import { useState } from 'react';

import type { Maybe } from '@/lib/types';
import { useRegionProvider } from '@/providers/RegionProvider';

import { VideoPlayer } from './components';
import { VideoPlayerBase } from './components/VideoPlayerBase';

import * as S from './Video.styles';
interface VideoProps {
  controls?: boolean;
  desktopAspectRatio?: { x: number; y: number };
  isCountDownType?: boolean;
  lazyLoad?: boolean;
  mediaUrl: Maybe<string>;
  mobileAspectRatio?: { x: number; y: number };
  poster?: string;
  setLoadingState?: (state: string) => void;
  title?: Maybe<string>;
  videoPlayOption?: string | null;
}

export const Video = ({
  desktopAspectRatio,
  isCountDownType = false,
  lazyLoad,
  mediaUrl,
  mobileAspectRatio,
  poster,
  setLoadingState,
  title,
  videoPlayOption = 'PlayOnClick',
}: VideoProps) => {
  const { locale } = useRegionProvider();
  const [openFullVideo, setOpenFullVideo] = useState<boolean>(false);

  const onClose = () => {
    setOpenFullVideo(false);
  };

  const onPlayCallback = () => {
    if (videoPlayOption === 'OpenPopup') {
      setOpenFullVideo(true);
    }
  };

  // Enable lazy loading by default for AutoplayLoop videos (hero banners)
  const isLazyLoadControlled = lazyLoad !== undefined;
  const shouldLazyLoad = lazyLoad ?? videoPlayOption === 'AutoplayLoop';

  return (
    <>
      {mediaUrl && (
        <S.VideoBox>
          <VideoPlayerBase
            data-testid='videoPlayer'
            desktopAspectRatio={desktopAspectRatio}
            isCountDownType={isCountDownType}
            lazyLoad={shouldLazyLoad}
            lazyLoadControlled={isLazyLoadControlled}
            localeCode={locale.code}
            mediaUrl={mediaUrl}
            mobileAspectRatio={mobileAspectRatio}
            onClose={onClose}
            playCallback={onPlayCallback}
            playOption={videoPlayOption ?? ''}
            poster={poster}
            setLoadingState={setLoadingState}
            title={title}
          />
        </S.VideoBox>
      )}
      {openFullVideo && (
        <VideoPlayer
          data-testid='videoPopupModal'
          isCountDownType={isCountDownType}
          isPopupMode={true}
          localeCode={locale.code}
          mediaUrl={mediaUrl}
          onClose={onClose}
          playOption={videoPlayOption ?? ''}
          poster={poster}
          title={title}
        />
      )}
    </>
  );
};
